// Spara-villkoret för sammanfattningen av en avslutad jakt (CompletedHuntModal).

/** Antalet i en rad; tomt eller ogiltigt fält (t.ex. under redigering i iOS) räknas som 1. */
export function rowCount(antal: number): number {
  return Number.isFinite(antal) && antal >= 1 ? Math.floor(antal) : 1;
}

export function totalKillCount(rows: { antal: number }[]): number {
  return rows.reduce((s, r) => s + rowCount(r.antal), 0);
}

/** Varför sammanfattningen inte kan sparas än, eller null när den kan det. */
export function huntSaveBlocker(rows: { antal: number }[]): string | null {
  return totalKillCount(rows) > 0 ? null : 'Inget fällt vilt i listan. Välj art under Fällt vilt och tryck + Lägg till.';
}
